import type { BookV1, MaterialV1 } from '@ilteducation/content-registry-types';
import { computed, Ref } from 'vue';
import { Filter, OriginalTitleFilter, useSearchContext, useSearchContexts } from "./index";

type ContentWithOriginalTitle = BookV1 | MaterialV1;

export const useContentByOriginalTitle = (
  content: Ref<ContentWithOriginalTitle>,
  contentType: string,
  globalFilters: Ref<Filter>,
): Ref<ContentWithOriginalTitle[]> => {
  const canHaveDuplicates = computed(() => !!content.value && !!content.value.originalTitle);

  const { createSearchId } = useSearchContexts();

  const searchId = computed(() => {
    if (!canHaveDuplicates.value) {
      return '';
    }

    return createSearchId(contentType, {
      filter: {
        ...globalFilters.value,
        ...OriginalTitleFilter(content.value.originalTitle!),
      },
    });
  });

  const contentWithSameOriginalTitle = computed(() => {
    const searchContext = useSearchContext(searchId.value, 100, canHaveDuplicates.value);
    return searchContext.contents.value;
  });

  return computed(() => {
    if (!canHaveDuplicates.value) {
      return [];
    }

    return contentWithSameOriginalTitle.value as ContentWithOriginalTitle[];
  });
};

export default useContentByOriginalTitle;
